




















































































































































































































































































































































import { Account } from '@/models/account';
import { Address } from '@/models/address';
import { UserAddress } from '@/models/user_address';
import { PreAlert } from '@/models/preAlert';
import { cloneDeep } from 'lodash';
import Vue from 'vue';
import { mapState } from 'vuex';
import dateFormat from '@/utils/dateFormat';
import { axios } from '@/plugins/axios';
import pdf from 'vue-pdf';

export default Vue.extend({
  components: {
    pdf,
  },
  data() {
    return {
      dialog: false,
      preAlert: new PreAlert(),
      adminId: 1,
    };
  },
  methods: {
    dateFormat,

    open(preAlert: PreAlert) {
      this.preAlert = cloneDeep(preAlert);

      if ((this.preAlert.user as Account)!.address! == null) {
        (this.preAlert.user as Account)!.address! = new Address();
      }
      if ((this.preAlert.user as Account)!.user_delivery_address! == null) {
        (this.preAlert
          .user as Account)!.user_delivery_address! = new UserAddress();
      }
      this.dialog = true;
    },

    getUserTypeText(userType: string) {
      if (userType == 'C') {
        return 'Customer';
      } else if (userType == 'A') {
        return 'Admin';
      } else if (userType == 'SA') {
        return 'Super Admin';
      } else {
        return 'Employee';
      }
    },

    getUserTypeColor(userType: string) {
      if (userType == 'C') {
        return 'primary';
      } else if (userType == 'A') {
        return 'red';
      } else if (userType == 'SA') {
        return 'warning';
      } else {
        return 'success';
      }
    },

    getPickupParishText(parishType: string) {
      if (parishType == 'MBJ') {
        return 'Montego Bay';
      } else {
        return 'Kingston';
      }
    },

    downloadImage(url: string) {
      const fileTypeIndex = url.lastIndexOf('.');
      const fileType = url.slice(fileTypeIndex, url.length);

      axios({
        url: url,
        method: 'GET',
        responseType: 'blob',
      }).then((response) => {
        const fileURL = window.URL.createObjectURL(new Blob([response.data]));
        const fileLink = document.createElement('a');

        fileLink.href = fileURL;
        fileLink.setAttribute(
          'download',
          `${this.preAlert.description} image.${fileType}`
        );
        document.body.appendChild(fileLink);

        fileLink.click();
      });
    },
  },
});
